import { render, staticRenderFns } from "./DeviceInfo.vue?vue&type=template&id=20b8dcc6&scoped=true"
import script from "./DeviceInfo.vue?vue&type=script&lang=ts"
export * from "./DeviceInfo.vue?vue&type=script&lang=ts"
import style0 from "./DeviceInfo.vue?vue&type=style&index=0&id=20b8dcc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b8dcc6",
  null
  
)

export default component.exports